import request from '@/utils/request'

// 获取一段交易期间的交易汇总查询
export function fetchTransSumList(data) {
  return request({
    url: '/merchant-api/transaction/getStatisticList',
    method: 'post',
    data
  })
}

export function fetchTransSumListAll(params) {
  return request({
    url: '/trade/trans/statistics/download',
    method: 'get',
    params
  })
}

export function fetchTransSumData(params) {
  return request({
    url: '/trade/trans/statistics/summary',
    method: 'get',
    params
  })
}

export function GetBankList(params) {
  return request({
    url: '/merchant-api/mch/bank/list',
    method: 'get',
    params
  })
}

export function GetMoreBankList(params) {
  return request({
    url: '/merchant-api/merchant/bank/list',
    method: 'get',
    params
  })
}

export function PostBankAdd(data) {
  return request({
    url: '/merchant-api/merchant/bank/add',
    method: 'post',
    data
  })
}

export function PostBankDelete(data) {
  return request({
    url: '/merchant-api/merchant/bank/delete',
    method: 'post',
    data
  })
}

export function getIsJTMerchant(data) {
  return request({
    url: '/merchant-api/mch/isJTMerchant ',
    method: 'get',
    data
  })
}

export function foreignExchangeDetail(params) {
  return request({
    url: '/merchant-api/transaction/foreignExchangeDetail',
    method: 'get',
    params
  })
}

// 分页查询分账交易列表接口
export function PostGetSplitPaymentOrderList(data) {
  return request({
    url: '/merchant-api/splitPayment/pageSplitPaymentOrderDetail',
    method: 'post',
    data
  })
}

// 下载分账交易列表接口
export function PostGetSplitPaymentOrderListDownload(data) {
  return request({
    url: '/merchant-api/fileDownload/splitPaymentDetail/async',
    method: 'post',
    data
  })
}

// 查询分账交易详情接口
export function GetSplitPaymentOrderDetail(params) {
  return request({
    url: '/merchant-api/splitPayment/getSplitPaymentOrderDetail',
    method: 'get',
    params
  })
}

// 【资金管理】-【资金设置】- 新增分账接收商户
export function PostSplitPaymentReceiverAdd(data) {
  return request({
    url: '/merchant-api/splitPayment/addReceiver',
    method: 'post',
    data
  })
}

// 【资金管理】-【资金设置】- 删除分账接收商户
export function PostSplitPaymentReceiverDelete(data) {
  return request({
    url: '/merchant-api/splitPayment/deleteReceiver',
    method: 'post',
    data
  })
}

// 【资金管理】-【资金设置】- 更新分账接收商户
export function PostSplitPaymentReceiverUpdate(data) {
  return request({
    url: '/merchant-api/splitPayment/updateReceiver',
    method: 'post',
    data
  })
}

// 【资金管理】-【资金设置】- 分页查询分账接收商户列表
export function PostGetSplitPaymentReceiverList(data) {
  return request({
    url: '/merchant-api/splitPayment/pageSplitPaymentReceiver',
    method: 'post',
    data
  })
}

// ==================== CardValidation 验卡接口 ====================
// 分页查询验卡列表
export function fetchCardValidationList(data) {
  return request({
    url: '/merchant-api/cardValidation/pageCardValidationForMch',
    method: 'post',
    data
  })
}

// 导出验卡列表
export function fetchCardValidationListDownload(data) {
  return request({
    url: '/merchant-api/fileDownload/cardValidation/async',
    method: 'post',
    data
  })
}

// 获取验卡详情（商户端）
export function fetchCardValidationDetail(params) {
  return request({
    url: '/merchant-api/cardValidation/getCardValidationDetailForMch',
    method: 'get',
    params
  })
}

// 获取验卡列表（客服管理端）
export function fetchCardVerificationList(data) {
  return request({
    url: '/merchant-api/customServiceOrder/pageCardValidation',
    method: 'post',
    data
  })
}

// 获取验卡详情（客服管理端）
export function fetchCardValidationDetailForMg(params) {
  return request({
    url: '/merchant-api/customServiceOrder/getCardValidationDetail',
    method: 'get',
    params
  })
}

// 获取多币种结算银行卡列表
export function GetMultiMchMoreBankList(params) {
  return request({
    url: '/merchant-api/merchant/bank/multiMchList',
    method: 'get',
    params
  })
}

// 新增多币种结算银行卡
export function PostMultiMchBankAdd(data = {}) {
  return request({
    url: '/merchant-api/merchant/bank/multiMchAdd',
    method: 'post',
    data
  })
}

// ==================== Payment Slip Validation 收款凭证核验接口 ====================
// 分页查询收款凭证核验列表
export function fetchPaymentSlipValidationList(data) {
  return request({
    url: '/merchant-api/mchPsvSettlement/pagePaymentSlipValidation',
    method: 'post',
    data
  })
}

// 导出收款凭证核验列表
export function fetchPaymentSlipValidationListDownload(data) {
  return request({
    url: '/merchant-api/fileDownload/paymentSlipValidation/async',
    method: 'post',
    data
  })
}

// 获取收款凭证核验详情
export function fetchPaymentSlipValidationDetail(params) {
  return request({
    url: '/merchant-api/paymentSlipValidation/detail',
    method: 'get',
    params
  })
}
